/* unplugin-vue-components disabled */import { render } from "./batch.vue?vue&type=template&id=bef4d5be&scoped=true"
import script from "./batch.vue?vue&type=script&lang=js"
export * from "./batch.vue?vue&type=script&lang=js"

import "./batch.vue?vue&type=style&index=0&id=bef4d5be&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef4d5be"]])

export default __exports__